var map = {
	"./404/NoMatch.jsx": 820,
	"./Account/Login.jsx": 1290,
	"./Account/Signup.jsx": 1078,
	"./Ads/AdRow.jsx": 961,
	"./Ads/AdUnit.jsx": 846,
	"./Ads/AdUnitPanorama.jsx": 1291,
	"./Ads/ConceptAdScript.jsx": 1292,
	"./Ads/InsiderAd.jsx": 866,
	"./Ads/PanoramaAdContainer.jsx": 1079,
	"./Ads/SkyscraperAdContainer.jsx": 1080,
	"./Ads/TakeoverAdContainer.jsx": 1081,
	"./Ads/TickerAdContainer.jsx": 905,
	"./Ads/TickerAdContainer2.jsx": 1034,
	"./Ads/TickerAdContainer3.jsx": 1293,
	"./Ads/TickerAdContainer4.jsx": 1294,
	"./Ads/TickerAdContainer5.jsx": 1295,
	"./Ads/TickerAdContainer6.jsx": 1296,
	"./ArticleFeed/Article.jsx": 1082,
	"./ArticleFeed/ArticleList.jsx": 1221,
	"./ArticleFeed/ArticlePage.jsx": 1297,
	"./ArticleFeed/ArticlePageMeta.jsx": 1222,
	"./ArticleFeed/ArticleShare.jsx": 1223,
	"./ArticleFeed/AuthorInfoLarge.jsx": 1224,
	"./ArticleFeed/AuthorInfoSmall.jsx": 1225,
	"./ArticleFeed/EmbedIframe.jsx": 1117,
	"./ArticleFeed/EmbedIframe_prod_02062022.jsx": 1298,
	"./ArticleFeed/FactBox.jsx": 1226,
	"./ArticleFeed/FbCommentBox.jsx": 1227,
	"./ArticleFeed/GoogleArticleRichCard.jsx": 1228,
	"./ArticleFeed/Poll.jsx": 1229,
	"./ArticleFeed/PollForm.jsx": 1230,
	"./ArticleFeed/PollResult.jsx": 1231,
	"./ArticleFeed/Slider.jsx": 1232,
	"./ArticleFeed/StoryNav.jsx": 1233,
	"./ArticleFeed/StoryNavItem.jsx": 1234,
	"./ArticleFeed/Target.jsx": 1235,
	"./ArticleFeed/Target_prod_02062022.jsx": 1299,
	"./ArticleFeed/TotalShares.jsx": 1236,
	"./ArticleFeed/VideoSummaries.jsx": 1237,
	"./ArticleLink.jsx": 834,
	"./BasicMeta.jsx": 899,
	"./Breakpoint.jsx": 962,
	"./ContactPage.jsx": 1300,
	"./ContentMeta.jsx": 861,
	"./EURO2020/EURO2020.jsx": 1301,
	"./EURO2020/EURO2020Meta.jsx": 1238,
	"./EnetpulseWidget.jsx": 900,
	"./Feedback/FeedbackForm.jsx": 1083,
	"./Feedback/FeedbackWidget.jsx": 901,
	"./Feedback/Stars.jsx": 944,
	"./Forms/Checkbox.jsx": 1084,
	"./Forms/Input.jsx": 1085,
	"./Forms/Textarea.jsx": 1086,
	"./InfiniteScrollLoader.jsx": 879,
	"./InstagramRenderer.jsx": 1239,
	"./Leagues/LeagueList.jsx": 1302,
	"./Loader.jsx": 832,
	"./Longform/Longform.jsx": 1303,
	"./Longform/LongformLanding.jsx": 1304,
	"./MMS/MMSPage.jsx": 821,
	"./Mail.jsx": 1240,
	"./MarkdownConverter.jsx": 1035,
	"./MediaPages/BlogList.jsx": 1305,
	"./MediaPages/BlogMeta.jsx": 1241,
	"./MediaPages/MediaItem.jsx": 1242,
	"./MediaPages/MediaList.jsx": 1243,
	"./MediaPages/MediaListContainer.jsx": 1118,
	"./MediaPages/PodMeta.jsx": 1306,
	"./MediaPages/PodcastList.jsx": 1307,
	"./Navigation/MegaDropdown.jsx": 963,
	"./Navigation/MobileNav.jsx": 906,
	"./Navigation/Nav.jsx": 907,
	"./Navigation/Nav2_08_01_2021.jsx": 1308,
	"./Navigation/Nav2_08_01_2021_pro.jsx": 1309,
	"./Navigation/Nav2_26_10_2020.jsx": 1310,
	"./Navigation/Navbar.jsx": 1087,
	"./Navigation/Navbar2.jsx": 1311,
	"./Navigation/Navbar_prod_22_01_2020.jsx": 1312,
	"./Navigation/Navbar_ticker_production.jsx": 1313,
	"./Navigation/Navbar_tickeren_prod_30_03_2020.jsx": 1314,
	"./Navigation/Notifications.jsx": 1244,
	"./Navigation/NotificationsWrapper.jsx": 1036,
	"./Navigation/SearchForm.jsx": 908,
	"./Navigation/TabMenu.jsx": 945,
	"./Navigation/production_Navbar.jsx": 1315,
	"./NewsFeed/AlternatingNews.jsx": 964,
	"./NewsFeed/ArticleList.jsx": 867,
	"./NewsFeed/ArticleListBox.jsx": 965,
	"./NewsFeed/ArticleListBox2.jsx": 1316,
	"./NewsFeed/ArticleListBox3.jsx": 1317,
	"./NewsFeed/ArticleListBoxEm.jsx": 1245,
	"./NewsFeed/BigNewsFirstItem.jsx": 966,
	"./NewsFeed/DualNews.jsx": 967,
	"./NewsFeed/Euro2020NewsFeedPage.jsx": 1318,
	"./NewsFeed/ExpandableBox.jsx": 1037,
	"./NewsFeed/FeaturedItem.jsx": 868,
	"./NewsFeed/FeedContainerBig.jsx": 946,
	"./NewsFeed/FeedContainerBox.jsx": 1088,
	"./NewsFeed/FeedContainerList.jsx": 1246,
	"./NewsFeed/FeedContainerRow.jsx": 1089,
	"./NewsFeed/FeedContainerSimple.jsx": 887,
	"./NewsFeed/FeedContainerSimpleBox.jsx": 1090,
	"./NewsFeed/FeedContainerSmall.jsx": 859,
	"./NewsFeed/FeedContainerTVguide.jsx": 1247,
	"./NewsFeed/FeedContainerText.jsx": 909,
	"./NewsFeed/FeedPicture.jsx": 869,
	"./NewsFeed/FeedText.jsx": 880,
	"./NewsFeed/LeagueResults.jsx": 1091,
	"./NewsFeed/LeagueTable.jsx": 1092,
	"./NewsFeed/LeagueWidgetsRow.jsx": 968,
	"./NewsFeed/NewsFeedHeading.jsx": 969,
	"./NewsFeed/NewsFeedMeta.jsx": 970,
	"./NewsFeed/NewsFeedPage.jsx": 1319,
	"./NewsFeed/NewsFeedPageIndex.jsx": 822,
	"./NewsFeed/PageWithSidebarsFodbold.jsx": 1320,
	"./NewsFeed/PopularVideos.jsx": 1093,
	"./NewsFeed/PopularVideosBox.jsx": 971,
	"./NewsFeed/RowWithThree.jsx": 902,
	"./NewsFeed/RowWithThreeBox.jsx": 1094,
	"./NewsFeed/RowWithTwo.jsx": 833,
	"./NewsFeed/StandardNews.jsx": 972,
	"./NewsFeed/TripleNews.jsx": 1321,
	"./NewsFeed/TripleNewsBox.jsx": 1050,
	"./NewsFeed/TripleNewsBox2.jsx": 1322,
	"./NewsFeed/TripleNewsBox3.jsx": 1323,
	"./NewsFeed/TripleNewsBoxEm.jsx": 1248,
	"./NewsFeed/TripleNewsBox_boldbanner.jsx": 1324,
	"./NewsFeed/VMArticleListBox.jsx": 1249,
	"./NewsFeed/VMNewsFeedPage.jsx": 1325,
	"./NewsFeed/VMTripleNewsBox.jsx": 1250,
	"./Overlay.jsx": 890,
	"./Page/App.jsx": 420,
	"./Page/CookieNotification.jsx": 1095,
	"./Page/DanishAdScript.jsx": 1326,
	"./Page/DefaultContentWrapper.jsx": 1051,
	"./Page/FacebookPageEmbed.jsx": 1096,
	"./Page/FollowButton.jsx": 870,
	"./Page/FollowEmail.jsx": 1097,
	"./Page/FollowFacebook.jsx": 1098,
	"./Page/FollowTwitter.jsx": 1099,
	"./Page/GoogleAnalyticsScript.jsx": 1327,
	"./Page/GooglePageHiding.jsx": 1328,
	"./Page/GoogleTagManagerScript.jsx": 1329,
	"./Page/Html.jsx": 1330,
	"./Page/MixpanelScript.jsx": 1331,
	"./Page/Modal.jsx": 1100,
	"./Page/OneTrust.jsx": 1332,
	"./Page/OneTrustScript.jsx": 1333,
	"./Page/OneTrustScript2.jsx": 1334,
	"./Page/OneTrustScript3.jsx": 1335,
	"./Page/PageWithSidebars.jsx": 840,
	"./Page/PageWithSidebarsArticle.jsx": 1336,
	"./Page/PageWithoutSidebars.jsx": 973,
	"./Page/PageWithoutSidebarsEm.jsx": 1251,
	"./Page/PageWithoutSidebarsTVguide.jsx": 1252,
	"./Page/Sticky.jsx": 1101,
	"./Page/TwitterFollowWidget.jsx": 1102,
	"./Page/UnsupportedBrowserNotification.jsx": 1103,
	"./Page/ViasportApp.jsx": 425,
	"./PageHeading.jsx": 862,
	"./Picture.jsx": 856,
	"./PictureWithPreload.jsx": 1052,
	"./PlayDuration.jsx": 1104,
	"./QUIZ/QUIZ.jsx": 1337,
	"./QUIZFB/QUIZFB.jsx": 1338,
	"./QuizRenderer.jsx": 1253,
	"./Ripple.jsx": 1038,
	"./Search/SearchListItem.jsx": 1254,
	"./Search/SearchPage.jsx": 1339,
	"./Search/SearchPageForm.jsx": 1255,
	"./ShareButton.jsx": 1256,
	"./Sidebar/BroadcastArea.jsx": 1053,
	"./Sidebar/BroadcastAreaFeed.jsx": 1105,
	"./Sidebar/Footer.jsx": 947,
	"./Sidebar/LiveArea.jsx": 1340,
	"./Sidebar/LiveMeta.jsx": 1257,
	"./Sidebar/LiveStreamListing.jsx": 1039,
	"./Sidebar/LongformFeed.jsx": 1106,
	"./Sidebar/SocialArea.jsx": 1107,
	"./Sidebar/StickyUnderNav.jsx": 1040,
	"./Sidebar/UserArea.jsx": 1054,
	"./Sidebar/ViaplayLiveFeed.jsx": 1055,
	"./Sidebar/ViasportLiveFeed.jsx": 1056,
	"./Teams/TeamList.jsx": 1341,
	"./TextPages/TextPage.jsx": 1342,
	"./TextPages/TextPageCookie.jsx": 1343,
	"./TextPages/TextPageCookiedeklarationen.jsx": 1344,
	"./Thumbnail.jsx": 871,
	"./TranslatedLink.jsx": 843,
	"./TranslatedLinkLeague.jsx": 1057,
	"./TvGuide/TvGuide.jsx": 1345,
	"./TvGuide/TvGuideMeta.jsx": 1258,
	"./TvGuide/TvGuideTemplate.jsx": 1346,
	"./TweetRenderer.jsx": 1259,
	"./VButton.jsx": 881,
	"./Video/SideScrollableContainer.jsx": 1058,
	"./Video/VideoList.jsx": 948,
	"./Video/VideoMeta.jsx": 1108,
	"./Video/VideoPage.jsx": 1347,
	"./VideoEmbed/EmbedPage.jsx": 823,
	"./VideoPlayer.jsx": 974,
	"./VideoPlayerMessageWrapper.jsx": 1041,
	"./VideoPlayerPlaceholder.jsx": 1260,
	"./WidgetPages/LiveScore.jsx": 1348,
	"./WidgetPages/Tables.jsx": 1349,
	"./WidgetPages/WidgetIndex.jsx": 1350,
	"./XLBYG/XLBYG.jsx": 1351,
	"./XLBYG/XLBYGMeta.jsx": 1261
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;


//////////////////
// WEBPACK FOOTER
// ./src/component ^\.\/.*\.jsx$
// module id = 824
// module chunks = 1